module.exports = __webpack_public_path__ + "35bc4c43e9c1a9fd7d1900847a5a7990.fbx";